import { Injectable, Inject } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { map, timeout, catchError } from 'rxjs/operators';
import { ApiCommonService } from 'cbc-shared-lib';
import { SZZA007AService, Szza007aRequest } from 'sg-api';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

@Injectable({
  providedIn: 'root'
})
export class UsedSzza007aService {
  /**
   * コンストラクタ
   * @param {SZZA007AService} sZZA007AService
   * @memberof InitialInfoService
   */
  constructor(private sZZA007AService: SZZA007AService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * ファイルリスト取得API呼び出し
   *
   * @param {*} value
   * @memberof UsedSzza007aService
   */
  fileDownload(request: Szza007aRequest): Observable<boolean> {
    // ファイル名が未指定の場合は、エラーを返却
    if (request.name == null || request.name == '') {
      return of(false);
    }

    return this.sZZA007AService.a10RSZZA007APost(this.apiCommonService.setRequestCommon(request))
      .pipe(
        map(response => {
          // ファイルとしてダウンロード
          this.anchorDownload(response, request.name);
          return true;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'sys', 'SZZA007A');
          return throwError(err.message);
        })
      );
    }

  /**
   * 渡されたBlobオブジェクトとファイル名を元に内部でAnchor要素を作成し、
   * ブラウザ上でファイルとしてダウンロードする
   * @param response 
   * @param filename 
   * @memberof UsedSzza007aService
   */
  anchorDownload(response: Blob, filename: string): void {
    // 取得した情報をアンカー要素のURLに指定
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(response);
    // ダウンロード属性を指定して、ファイルとしてダウンロードするように指定
    downloadLink.setAttribute('download', filename);
    document.body.appendChild(downloadLink);
    // アンカー要素をクリックしてダウンロード
    downloadLink.click();
    // 追加した要素を削除
    document.body.removeChild(downloadLink);
  }
}